import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import classNames from './../utils/classNames';

import {
    financesSetFilterTime,
    financesSetFilterType,
    financesSetFilterStatus
} from './../store/finances/actions';
import { settingsFetchIfNeeded } from './../store/settings/actions';
import { getFinanceTypes, getFinanceStatuses } from './../store/finances/selectors';

import Dropdown from './Dropdown';
import Select from './Select';
import FinancesModal from './FinancesModal';
import FinancesCancelModal from './FinancesCancelModal';

class FinancesTableFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState(state => Object.assign({}, state, {
            isModalOpen: !state.isModalOpen
        }));
    }

    componentDidMount() {
        const { loadSettings } = this.props;
        loadSettings();
    }

    render() {
        const {
            className,
            filterTimesLong,
            filterTypes,
            filterStatuses,
            filter,
            setFilterTime,
            setFilterType,
            setFilterStatus,
            available,
            pending,
            isLoading,
            execution,
            translate
        } = this.props;
        const { isModalOpen } = this.state;

        const availableClassName = classNames({ 'text-warning': available <= 0 });
        return (
            <div className={className}>
                <div className="row vertical">
                    <div className="col-2">
                        <Dropdown text={translate(`timeFilter.${filter.time}`)} closeAlways>
                            <Select className="menu menu-selectable" onChange={setFilterTime} value={filter.time}>
                                {filterTimesLong.map(item =>
                                    <li key={item} value={item} className="menu-item">{translate(`timeFilter.${item}`)}</li>
                                )}
                            </Select>
                        </Dropdown>
                    </div>
                    <div className="col-2">
                        <Dropdown text={translate(`financeTypeFilter.${filter.type}`)} closeAlways>
                            <Select className="menu menu-selectable" onChange={setFilterType} value={filter.type}>
                                {filterTypes.map(item =>
                                    <li key={item} value={item} className="menu-item">{translate(`financeTypeFilter.${item}`)}</li>
                                )}
                            </Select>
                        </Dropdown>
                    </div>
                    <div className="col-2">
                        <Dropdown text={translate(`financeStatusFilter.${filter.status}`)} closeAlways>
                            <Select className="menu menu-selectable" onChange={setFilterStatus} value={filter.status}>
                                {filterStatuses.map(item =>
                                    <li key={item} value={item} className="menu-item">{translate(`financeStatusFilter.${item}`)}</li>
                                )}
                            </Select>
                        </Dropdown>
                    </div>
                    <div className="col-1"></div>
                    <div className="col-3 balance ta-right">{!isLoading && !!pending &&
                        <span>Pending balance: <b>${(pending / 100).toFixed(2)}</b></span>
                    }</div>
                    <div className="col-3 balance ta-center">{!isLoading &&
                        <span>Available balance: <b className={availableClassName}>${(available / 100).toFixed(2)}</b></span>
                    }</div>
                    <div className="col-2">
                        <button
                            className="btn btn-bright"
                            type="button"
                            disabled={isLoading || (available === 0 && pending === 0)}
                            onClick={this.toggleModal}
                        >Request withdrawal</button>
                    </div>
                </div>
                {execution === 0
                    ? <FinancesModal isOpen={isModalOpen} toggleModal={this.toggleModal} />
                    : <FinancesCancelModal isOpen={isModalOpen} toggleModal={this.toggleModal} />
                }
            </div>
        );
    }
};

const mapStateToProps = state => {
    const translate = getTranslate(state.locale);
    const filterTimesLong = state.settings.filterTimesLong;
    const filterTypes = getFinanceTypes(state);
    const filterStatuses = getFinanceStatuses(state);
    const { filter, available, pending, execution } = state.finances;
    const isLoading = state.finances.isFetching;
    return { filter, filterTimesLong, filterTypes, filterStatuses, available, pending, isLoading, execution, translate };
};

const mapDispatchToProps = dispatch => {
    return {
        loadSettings: () => dispatch(settingsFetchIfNeeded()),
        setFilterTime: value => dispatch(financesSetFilterTime(value)),
        setFilterType: value => dispatch(financesSetFilterType(value)),
        setFilterStatus: value => dispatch(financesSetFilterStatus(value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FinancesTableFilter);



// WEBPACK FOOTER //
// ./src/components/FinancesTableFilter.js